import React from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import Login from "../Pages/Authentication/Login";
import Dashboard from "../Pages/Dashboard/Dashboard";
import Products from "../Pages/Products/Index";
import AmazonProducts from "../Pages/ProductListings/Amazon";
import CarrefourProducts from "../Pages/ProductListings/Carrefour";
import Scraper from "../Pages/Scraper/Index";
import NotFound from "../Pages/Error/Error404";
import UserManagement from "../Pages/UserManagement/Index";
import CartDetails from "../Pages/UserManagement/Cart";
import Banners from "../Pages/Banners/Index";
import AddBanner from "../Pages/Banners/AddBanner";
import EditBanner from "../Pages/Banners/EditBanner";
import Categories from "../Pages/Categories/Index";
import EditCategory from "../Pages/Categories/EditCategory";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicRoutes />}>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
      </Route>

      {/* Private Routes */}
      <Route element={<PrivateRoutes />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/amazon" element={<AmazonProducts />} />
        <Route path="/products/carrefour" element={<CarrefourProducts />} />
        <Route path="/scraper" element={<Scraper />} />
        <Route path="/users" element={<UserManagement/>} />
        <Route path="/users/cart/:id" element={<CartDetails />} />
        <Route path="/banners" element={<Banners/>} />
        <Route path="/banners/add" element={<AddBanner/>} />
        <Route path="/banners/edit/:id" element={<EditBanner/>} />
        <Route path="/categories" element={<Categories/>} />
        <Route path="/category/edit/:id" element={<EditCategory/>} />
      </Route>
      {/* Fallback */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
